export default "__VITE_ASSET__BqPkicoN__"